import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// components/gitbiz/solutions/cs-firm/index.jsx (rendered by the deleted
// app/(homes)/(hrms)/hrms-software/solutions/cs-firm/page.jsx) onto the content
// engine (template "solution"). Copy, images, links match the original.
// SEO comes from GeneralPageSEOMetadata.json via <SEO> (its "cs-firm" entry).

export const csFirm: ContentPage = {
  slug: "solutions/cs-firm",
  template: "solution",
  seo: {
    title: "Streamlined Solutions for CS Firms | GetBiz Solutions",
    description: "GetBiz Solutions delivers tools for CS firms, ensuring smooth regulatory task management, compliance, and workflow automation for effective services.",
    keywords: [
      "CS firm software",
      "compliance management",
      "workflow automation",
      "regulatory tasks",
      "CS firm solutions",
      "compliance software",
      "legal compliance tools",
      "firm management",
    ],
    ogImage: "/assets/data/seoimages/cs-firm.webp",
  },
  solution: {
    hero: {
      title: "Efficiently manage client tasks and compliance.",
      description: "Enhance your firm’s efficiency with streamlined operations and automated workflows.",
      image: "/assets/images/img/cs_firm_solutions.webp",
      imageAlt: "cs_firm_solutions",
      bgImage: "/assets/images/full-width-images/section-bg-10.jpg",
      ctaPrimary: { label: "Start 15 Days Trial", href: "/pricing/" },
      ctaSecondary: { label: "Book A Demo", href: "/book-demo/" },
    },
    servicesTitle: "Corporate Services with HRMS for CS Firms",
    services: [
      { title: "Task Scheduling and Automation", description: "Assign tasks to staff and automate reminders for important company compliance filings and deadlines." },
      { title: "Client Document Handling", description: "Manage client documents and filings efficiently with automated tracking and easy access to files." },
      { title: "Employee Performance Tracking", description: "Automate the tracking of employee performance, ensuring tasks are completed on time and accurately." },
      { title: "Client Interaction Management", description: "Automate follow-up emails, reminders, and updates to ensure smooth communication with corporate clients." },
      { title: "Leave and Attendance Automation", description: "Manage staff attendance, leaves, and time-offs seamlessly with HRMS tools for better workforce management." },
      { title: "Regulatory Compliance", description: "Track and monitor all regulatory compliance activities for clients with automatic updates and reminders." },
    ],
    ctaStrip: {
      description: "Book a personalized demo to see how our solutions can transform your business and boost your efficiency.",
      button: { label: "Book A Demo", href: "/book-demo/" },
    },
    faqDescription: "Learn how GetBiz Solutions provides tools for CS firms to manage regulatory tasks more effectively. Our FAQs cover document management, workflow automation, and compliance tracking. Discover how our tools streamline your firm’s operations, improve accuracy, and help you meet all statutory requirements with confidence, freeing up time for more client-focused work.",
    metaKey: "cs-firm",
  },
  sections: [],
};
